<template>
  <v-container v-if="userAllowedImportExport" fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-form v-model="valid">
          <v-card class="pa-4">
            <CustomerSelect v-model="customerId" externaledit clearable style="max-width: 300px;">
            </CustomerSelect>
            <v-btn :disabled="!valid" class="mt-4" color="primary" style="text-transform: none;" @click="exportFile">
              {{ $t('servicesystem.common_objects.commonterms.export') }}
            </v-btn>
            <v-btn :disabled="!valid" class="mt-4 ml-2" color="secondary" style="text-transform: none;"
              @click="exportFileSA">
              Export (Only active contract)
            </v-btn>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>

  <NoImportExportPermission v-else>
  </NoImportExportPermission>
</template>


<script>
import client from "@/api/client";
import CustomerSelect from '@/components/Inputs/EntityDropdowns/CustomerSelect2.vue';
import NoImportExportPermission from '../landingpages/NoImportExportPermission.vue';

export default {
  name: "ExportMachines",
  props: [],
  components: {
    CustomerSelect,
    NoImportExportPermission,
  },

  data() {
    return {
      valid: false,
      customerId: null,
    };
  },

  methods: {
    exportFile() {
      client()
        .post(`/api2/serviceprovider/statistics/ExportMachines`, this.queryPreset)
    },
    exportFileSA() {
      const filter = { CustomerId: this.customerId, OnlyWithActiveContract: true };
      client()
        .post(`/api2/serviceprovider/statistics/ExportMachinesServiceAgreement`, filter);
    },
  },

  computed: {
    queryPreset() {
      return {
        CustomerId: this.customerId,
        Type: "Machines"
      };
    }
  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>